import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Ptdc from "../utility/ptdc";

// eslint-disable-next-line no-undef
const serverUrl = process.env.REACT_APP_SERVER_URL;
// eslint-disable-next-line no-undef
const rpcUrl = process.env.REACT_APP_RPC_URL;

const Collections = () => {
  const [collectionsData, setCollectionsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const config = useSelector((state) => state.config);
  const navigate = useNavigate();

  const handleCollectionClick = (collection) => {
    navigate(`/collection/${collection.contractAddress}`, {
      state: { collection },
    });
  };

  const contractABI = [
    "function name() view returns (string)",
    "function symbol() view returns (string)",
    "function totalSupply() view returns (uint256)",
    "function maxSupply() view returns (uint256)",
    "function remainingSupply() view returns (uint256)",
    "function owner() view returns (address)",
  ];

  const fetchData = async () => {
    try {
      // Fetch collections from our backend first
      const backendResponse = await axios.get(`${serverUrl}/api/collections`);
      const backendCollections = backendResponse.data.data;

      // Then fetch blockchain data
      const provider = new ethers.JsonRpcProvider(
        rpcUrl,
        { name: "amoy", chainId: 80002 },
        { batchMaxCount: 1 },
      );

      const blockchainPromises = backendCollections.map(async (collection) => {
        try {
          const contract = new ethers.Contract(
            collection.contractAddress,
            contractABI,
            provider,
          );

          const [totalSupply, maxSupply, remainingSupply] = await Promise.all([
            contract.totalSupply(),
            contract.maxSupply(),
            contract.remainingSupply(),
          ]);

          return {
            ...collection,
            blockchainData: {
              totalSupply: totalSupply.toString(),
              maxSupply: maxSupply.toString(),
              remainingSupply: remainingSupply.toString(),
            },
          };
        } catch (err) {
          setErrors((prev) => ({
            ...prev,
            [collection.contractAddress]: err.message,
          }));
          return {
            ...collection,
            blockchainData: {
              totalSupply: "0",
              maxSupply: collection.totalSupply?.toString() || "N/A",
              remainingSupply: collection.totalSupply?.toString() || "N/A",
            },
          };
        }
      });

      const results = await Promise.all(blockchainPromises);
      setCollectionsData(results);
    } catch (err) {
      setErrors((prev) => ({
        ...prev,
        general: err.message,
      }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="public-state public-state-loading w-full max-w-7xl mx-auto bg-white rounded-xl shadow-lg">
        <div className="flex items-center justify-center p-6">
          <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
      </div>
    );
  }

  if (errors.general) {
    return (
      <div className="public-state public-state-error w-full max-w-7xl mx-auto bg-red-50 rounded-xl shadow-lg">
        <div className="p-6">
          <p className="text-red-500">Error: {errors.general}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="collections-page">
      {config.clientConfig?.data && ( // Conditional rendering for the banner
        <div
          className="container-cust-fluid header"
          style={{
            backgroundImage: `url(${config.clientConfig.data.bannerImgUrl})`,
          }}
        >
          <div className="container-cust">
            <img
              className="custom-logo"
              src={config.clientConfig.data.profilePicImgUrl}
              alt=""
            />
          </div>
        </div>
      )}
      <div className="container-cust content mx-auto">
        <div className="title-container">
          <div>
            <h1>{config.clientConfig?.data?.name}</h1>
            {/* <span>5 Collezioni</span> */}
            {collectionsData && collectionsData.length === 0 && (
              <span>Non sono presenti collezioni</span>
            )}
            {collectionsData && collectionsData.length === 1 && (
              <span>1 Collezione</span>
            )}
            {collectionsData && collectionsData.length > 1 && (
              <span>{collectionsData.length} Collezioni</span>
            )}
          </div>
        </div>
        <div className="grid grid-cols-12 gap-x-4 gap-y-6">
          {collectionsData.map((collection) => (
            <div
              key={collection.contractAddress}
              className="collection-card-cell col-span-12 sm:col-span-6 lg:col-span-4"
            >
              <article className="collection-card product-preview">
                <div className="image-container">
                  <img
                    src={collection.image}
                    alt={collection.name}
                    loading="lazy"
                  />
                </div>
                <div className="text-container">
                  <div className="details-container">
                    <div className="detail">ID:</div>

                    {/*                       <div className="detail">
                        Address: {collection.contractAddress}
                      </div> */}

                    <div className="detail">
                      {collection.blockchainData?.totalSupply || "0"}/
                      {collection.blockchainData?.maxSupply || "N/A"}
                    </div>
                  </div>
                  <Ptdc
                    // pretitle={"Tipologia: " + collection.type}
                    title={collection.name}
                    // description={truncateDescription(collection.description, 170)}
                  />
                  <button
                    onClick={() => handleCollectionClick(collection)}
                    className="cta cta-standard"
                  >
                    Scopri la collezione
                  </button>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Collections;
